package one.healthium.data.paywall

import one.healthium.data.paywall.storage.LocalPaywallStorage
import one.healthium.domain.paywall.PaywallRepository
import one.healthium.domain.paywall.models.Paywall
import one.healthium.domain.paywall.models.PaywallSet

class AppPaywallRepository(
    private val localPaywallStorage: LocalPaywallStorage
) : PaywallRepository {
    override suspend fun getPaywallSet(id: String): PaywallSet? {
        return localPaywallStorage.getPaywallSet(id)
    }

    override suspend fun getPaywall(id: String): Paywall? {
        return localPaywallStorage.getPaywall(id)
    }
}